import { render, staticRenderFns } from "./labelEditor.vue?vue&type=template&id=099e22e3&"
import script from "./labelEditor.vue?vue&type=script&lang=js&"
export * from "./labelEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports